export const COD_PAYMENT_TYPE_VIEW = {
  activeProduct: 'activeProduct',
  sendIXOneCapture: 'sendIXOneCapture',
};

export const COD_PAYMENT_DESCRIPTION = {
  activeProduct: 'Make active product',
  sendIXOneCapture: 'Send products to capture',
};
